/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 19/10/2022
 */
import BaseObject from "@shared/BaseObject.js";
import {editContractDialog, signContractDialog} from "@/core/modules/DocSign/data/dialogs/dialog";
import {yesNoDialog} from "@/core/components/Dialogs/dialog";
import {AssignToOptions} from "@/core/modules/DocSign/data/DocSignAssignToData";
import {createDialogLazy} from "@/utils/helpers-external";
let SendForSignatureDialog = () => import("@/core/modules/coach/Resources/Agreements/SendForSignatureDialog.vue");
let LegalDocPickerDialog = () => import("@/core/components/Dialogs/PickerDilaog/LegalDocPickerDialog.vue");
let sendForSignatureDialog = createDialogLazy(SendForSignatureDialog)
let legalDocPickerDialog = createDialogLazy(LegalDocPickerDialog)

export default class RequestSignatureFlowHelper extends BaseObject {

	constructor() {
		super();
	}

	async pickAndSendForSignature(clientProfile, options = {}){
		let legalDocTemplate = await legalDocPickerDialog()
		if(legalDocTemplate){
			return this.templateSendForSignature(legalDocTemplate, clientProfile, options)
		}
	}

	async templateSendForSignature(template, clientProfile, options = {}){
		let clientLimit = options.clientLimit || 1
		let packageItem = options.packageItem || null
		let isGroupSharing = options.isGroupSharing
		console.log("templateSendForSignature: template = ", template)
		if(template.isEditable){
			let canProceed = await this.validateTemplate(template)
			if(!canProceed){
				let templateLocal = await this.editTemplate(template)
				if(!templateLocal){
					return
				}
				return this.templateSendForSignature(templateLocal, clientProfile, options)
			}
		}

		template.setCoachDateSignedNow()

		template = await this.ensureCoachFieldsAreFilledIn(template)
		if(!template){
			return
		}

		let isReadonly = clientProfile != null && !Array.isArray(clientProfile)
		console.log("templateSendForSignature: clientProfile = ", clientProfile, ", res = ", isReadonly)


		let res = await sendForSignatureDialog({
			templateItem: template,
			clientProfileProp: clientProfile,
			clientProfileReadonly: isReadonly,
			clientLimit: clientLimit,
			packageItem: packageItem,
			isGroupSharing: isGroupSharing
		})

		return res
	}

	async editTemplate(template) {
		template.setCoachDateSignedNow()
		let templateLocal = await editContractDialog({
			template: template,
			readonly: !template.isEditable
		})
		return templateLocal
	}



	async validateTemplate(template){
		let canProceed = true

		let {isCoachSignElemPresent, isClientSignElemPresent} = template.checkRequiredFieldsPresent()

		// console.log("validateTemplate: ", isCoachSignElemPresent, isClientSignElemPresent)
		if(!isCoachSignElemPresent || !isClientSignElemPresent){
			let text = (isCoachSignElemPresent ? "" : "for yourself")
				+ ((isCoachSignElemPresent || isClientSignElemPresent) ? "" : " and ")
				+ (isClientSignElemPresent ? "" : "for your client")
			let errorMessage = "This document is missing a signature field " + text + ". Would you like to add it?"
			canProceed = !await yesNoDialog({
				title: "Warning",
				message: errorMessage,
				yesTitle: "Ok, I'll add",
				noTitle: "Don't add"
			})
		}
		return canProceed
	}

	async ensureCoachFieldsAreFilledIn(template){
		let canProceed = true

		let areFieldsFilledIn = template.checkCoachFieldsFilledIn()

		if(!areFieldsFilledIn){

			let errorMessage = "There are some fields assigned to you that are not filled in. " +
				"Would you like to fill them in now before sending this agreemeent?" +
				"<br/><br/>" +
				"You can still send the document, and you will be prompted to fill it in after your client completes this document first."
			canProceed = await yesNoDialog({
				title: "Document not filled in",
				message: errorMessage,
				yesTitle: "Fill in the document now",
				noTitle: "Skip and send as is"
			})
			if(canProceed){

				template = await signContractDialog({
					currentSigner: AssignToOptions.COACH,
					signOnCompletion: false,
					hideCancelButton: false,
					template: template,
					updateTemplatePromise: async (template) => template
				})
				if(template){
					let areFieldsFilledIn = template.checkCoachFieldsFilledIn()
					if(!areFieldsFilledIn){
						this.toastWarn("Some of the fields assigned to coach are not filled in.")
					}

					return this.ensureCoachFieldsAreFilledIn(template)
				} else {
					return null
				}
			} else {
				return template
			}
		}
		return template
	}
}
